import { computed, ref } from 'vue';
import { TOOLTIPS } from '../constants/constants';
import { useIsMobile } from '../../../common/js/composables/is-mobile';

const funds = ref(null);

const nameFilterOptions = ref([]);
const fundTypeFilterOptions = ref([]);
const countryFilterOptions = ref([]);
const investmentPeriodFilterOptions = ref([]);
const currencyFilterOptions = ref([]);
const riskGroupFilterOptions = ref([]);

const activeFilters = ref([]);
const nameFilters = ref([]);

const termFilters = ref([]);
const riskFilters = ref([]);
const fundTypeFilters = ref([]);
const countryFilters = ref([]);
const panelModel = ref([]);

const panelOptionsDesktop = computed(() => [
	{ label: 'A befektetési alap devizája', options: [...currencyFilterOptions.value], tooltip: TOOLTIPS.CURRENCY },
	{ label: 'Alapok típusa', options: [...fundTypeFilterOptions.value] },
	{ label: 'Földrajzi kitettség', options: [...countryFilterOptions.value] }
]);

const panelOptionsMobile = computed(() => [
	{ label: 'Befektetési időtáv', options: [...investmentPeriodFilterOptions.value] },
	{ label: 'Kockázatvállalás', tooltip: TOOLTIPS.RISK, options: [...riskGroupFilterOptions.value] },
	...panelOptionsDesktop.value
]);

const { isLargeDesktop } = useIsMobile();
const filterGroups = computed(() => {
	const panelOptions = !isLargeDesktop.value ? panelOptionsMobile.value : panelOptionsDesktop.value;
	const flattenedOptions = panelOptions.reduce((acc, panel) => {
		return acc.concat(panel.options);
	}, []);

	return [
		{ model: nameFilters, options: nameFilterOptions.value },
		{ model: termFilters, options: investmentPeriodFilterOptions.value },
		{ model: riskFilters, options: riskGroupFilterOptions.value },
		{ model: panelModel, options: flattenedOptions }
	];
});

const allFilterOption = computed(() => [
	...investmentPeriodFilterOptions.value,
	...riskGroupFilterOptions.value,
	...currencyFilterOptions.value,
	...fundTypeFilterOptions.value,
	...countryFilterOptions.value
]);

const resetFilters = () => {
	activeFilters.value = [];
	nameFilters.value = [];
	termFilters.value = [];
	riskFilters.value = [];
	panelModel.value = [];
};

const filterFunds = (filters) => {
	let results = funds.value;
	const currentFilters = filters || activeFilters.value;

	if (nameFilters.value.length > 0) {
		results = results.filter((fund) => nameFilters.value.includes(fund.name));
	}

	const riskFilters = riskGroupFilterOptions.value.map((filterOption) => filterOption.key);
	if (riskFilters.some((filter) => currentFilters.includes(filter))) {
		results = results.filter((fund) => currentFilters.includes(fund.riskGroup));
	}

	const currencyFilters = currencyFilterOptions.value.map((filterOption) => filterOption.key);
	if (currencyFilters.some((filter) => currentFilters.includes(filter))) {
		results = results.filter((fund) => currentFilters.includes(fund.currency));
	}

	const fundTypeFilters = fundTypeFilterOptions.value.map((filterOption) => filterOption.key);
	if (fundTypeFilters.some((filter) => currentFilters.includes(filter))) {
		results = results.filter((fund) => currentFilters.includes(fund.fundType));
	}

	const countryFilters = countryFilterOptions.value.map((filterOption) => filterOption.key);
	if (countryFilters.some((filter) => currentFilters.includes(filter))) {
		results = results.filter((fund) => currentFilters.includes(fund.geographicExposure));
	}

	const investmentPeriodFilters = investmentPeriodFilterOptions.value.map((filterOption) => filterOption.key);
	if (investmentPeriodFilters.some((filter) => currentFilters.includes(filter))) {
		results = results.filter((fund) => currentFilters.includes(fund.investmentPeriod));
	}

	return results;
};

export const useStore = () => ({
	funds,
	activeFilters,
	nameFilters,
	termFilters,
	riskFilters,
	countryFilters,
	fundTypeFilters,
	panelModel,
	nameFilterOptions,
	fundTypeFilterOptions,
	countryFilterOptions,
	investmentPeriodFilterOptions,
	panelOptionsDesktop,
	panelOptionsMobile,
	filterGroups,
	allFilterOption,
	resetFilters,
	filterFunds,
	currencyFilterOptions,
	riskGroupFilterOptions
});
